import React, { useRef, useState } from 'react';
import api from '../apiConnector'

const noop = () => {};

const FileUploader = ({onUploaded = noop,devis,code,title}) => {
  // Create a ref to attach to the hidden file input
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  // 1. Trigger the hidden file input when the custom button is clicked
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  // 2. Handle the file selection and upload to the server
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Optional: Validate file size or type here
    console.log(`Selected file: ${file.name}`);

    // Create FormData object to send binary data
    const formData = new FormData();
    formData.append('document', file); // 'document' is the key your backend expects
    
    try {
        setUploading(true);

        const response = await fetch(api.uploadFmaDoc(devis.typedId(),code), {
            method: 'POST',
            body: formData,
            // Note: Do NOT set Content-Type header manually when using FormData.
            // The browser will automatically set it to multipart/form-data with the correct boundary.
        });

        if (response.ok) {
            const data = await response.json();
            onUploaded(data)
            console.log('Server response:', data);
        } else {
            throw new Error('Server responded with an error status.');
        }

    } catch (error) {
      console.error('Upload failed:', error);
    } finally {
      setUploading(false);
      // Reset the input value so the same file can be uploaded again if needed
      event.target.value = '';
    }
  };

  return (
    <div style={{ padding: '1rem 0 1rem 1rem', fontFamily: 'sans-serif' }}>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }} // Keeps it completely invisible
        accept=".pdf" // Optional: Restrict file types
      />

      {/* Your custom styled button */}
      <button
        onClick={handleButtonClick}
        disabled={uploading}
        className="upload_button"
      >
        {uploading ? '...' : title}
      </button>
    </div>
  );
};

export default FileUploader;